const log =
  Number(process.env.DEBUG_FLAG) === 1 ? console.log.bind(console) : () => {};

export const debugLog = (message) => {
  log(`path: ${"\u001b[34m"}${location.pathname}`);
  log(message);
};
